"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _onEnterPressed = _interopRequireDefault(require("../../../common/utils/onEnterPressed")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _checkbox = require("../styles/checkbox"),
    Checkbox = function Checkbox(a) {
  var b = a.checked,
      c = a.onChange,
      d = a.children,
      e = a.className,
      f = a.disabled,
      g = f ? void 0 : c;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _checkbox.CHECKBOX_CONTAINER)({
      disabled: f
    }), "check-box", {
      "check-box__checked": b
    }, {
      "check-box__disabled": f
    }, e),
    onKeyDown: (0, _onEnterPressed["default"])({
      onClick: g
    }),
    onClick: g,
    tabIndex: 0,
    role: "button"
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _checkbox.CHECKBOX)(b), "check-box__box")
  }, b && _react["default"].createElement(_Icon["default"], {
    className: "check-box__box__check-icon",
    name: "success",
    color: b ? "white" : "monkey",
    size: 12
  })), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_checkbox.CHECKBOX_CONTENT, "check-box__content")
  }, d));
},
    _default = (0, _react.memo)(Checkbox);

exports["default"] = _default;